/**
 * Returns true when `pathname` has a path segment that exactly matches one of
 * the provided `segments`. Matching is case-sensitive and full-segment only,
 * so `/ppc/foo` matches `["ppc"]` but `/some-ppc-thing/foo` does not.
 */
function hasSegmentInPath(
  pathname: string | undefined | null,
  segments: readonly string[],
): boolean {
  if (!pathname || segments.length === 0) {
    return false;
  }

  const pathSegments = pathname.split("/");

  return pathSegments.some((part) => segments.includes(part));
}

export { hasSegmentInPath };
